import { ref } from 'vue'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'

export const isSessionRestoring = ref(false)
export const isSessionRestoreComplete = ref(false)

let restoreSessionInFlight: Promise<boolean> | null = null
let sessionRestoreSettled = false
let lastRestoreResult = false

export function beginSessionRestore (): void {
  isSessionRestoring.value = true
}

export function endSessionRestore (): void {
  isSessionRestoring.value = false
}

export function resetSessionRestoreState (): void {
  isSessionRestoring.value = false
  isSessionRestoreComplete.value = false
  sessionRestoreSettled = false
  lastRestoreResult = false
  restoreSessionInFlight = null
}

/**
 * Após logout explícito: libera o auth observer para redirecionar ao login, mas mantém
 * `sessionRestoreSettled` falso para que um novo login possa restaurar a sessão sem reload.
 */
export function finalizeLogoutSessionState (): void {
  isSessionRestoring.value = false
  isSessionRestoreComplete.value = true
  sessionRestoreSettled = false
  lastRestoreResult = false
  restoreSessionInFlight = null
}

export function markSessionRestoreComplete (): void {
  isSessionRestoreComplete.value = true
  sessionRestoreSettled = true
}

export function finalizeSessionRestore (restored: boolean): void {
  lastRestoreResult = restored
  endSessionRestore()
  sessionRestoreSettled = true
  isSessionRestoreComplete.value = true
}

/**
 * Uma restauração por carregamento. Não há atalho para quem já está `logged`: a sessão bearer
 * herdada conta como logada e é justamente ela que precisa passar pelo `restoreSession` para
 * virar cookie. O próprio `restoreSession` devolve cedo, sem rede, quando não há o que fazer.
 */
export async function restoreSessionOnce (): Promise<boolean> {
  const authStore = useAuthenticationStore()

  if (sessionRestoreSettled) {
    return authStore.logged || lastRestoreResult
  }

  if (restoreSessionInFlight != null) {
    return restoreSessionInFlight
  }

  beginSessionRestore()

  restoreSessionInFlight = authStore.restoreSession()
    .then((restored) => {
      lastRestoreResult = restored

      return restored
    })
    .finally(() => {
      restoreSessionInFlight = null
      endSessionRestore()
      sessionRestoreSettled = true
      isSessionRestoreComplete.value = true
    })

  return await restoreSessionInFlight
}
